export default "__VITE_ASSET__Cnw$5jpw__"